import { sectionMetrics } from "../../model/sectionMetrics";
import { DeathList } from "./DeathList";
import { DeathStats } from "./DeathStats";
import { DeathTimeline } from "./DeathTimeline";
import { KillerCards } from "./KillerCards";
import { OtherFindings } from "./OtherFindings";
import type { SectionProps } from "./SectionProps";

// «Смерти»: сколько и сколько времени мёртвым, шкала матча и каждая смерть с обстановкой
// и потерей команды. Невыгодные драки, смерти от башен и потери во время возрождения — метки
// у смертей, поэтому их находки отдельными карточками не повторяются. Убийца, который
// убивал снова и снова, — карточкой с советом, если его ещё нет наверху.
// Разбор без обстановки смертей — убийцы карточками и шкала; без подробностей — карточки находок.
export const DeathsSection = ({ report, findings, featured }: SectionProps) => {
  const { details, match } = report;
  if (details === null || details.deaths.length === 0) {
    return <OtherFindings findings={findings} />;
  }
  if (!details.deaths.some((death) => death.dead_for_s > 0)) {
    return (
      <>
        <KillerCards deaths={details.deaths} findings={findings} />
        <DeathTimeline deaths={details.deaths} durationS={match.duration_s} />
        <OtherFindings findings={findings} shown={["killed_by_hero"]} hasContent />
      </>
    );
  }
  const metrics = sectionMetrics(details, "deaths");
  const repeatKillers = findings.filter(
    (finding) => finding.code === "killed_by_hero" && !featured.includes(finding),
  );
  return (
    <>
      <DeathStats
        deaths={details.deaths}
        timeDead={metrics.find((metric) => metric.metric === "time_dead_share")}
      />
      {repeatKillers.length > 0 && (
        <KillerCards deaths={details.deaths} findings={repeatKillers} onlyRepeat />
      )}
      <DeathTimeline
        deaths={details.deaths}
        durationS={match.duration_s}
        markFights
        laneEndS={details.lane?.points[0]?.time_s}
      />
      <DeathList deaths={details.deaths} />
      <OtherFindings
        findings={findings}
        shown={[
          "killed_by_hero",
          "died_outnumbered",
          "died_alone",
          "costly_death",
          "killed_by_objective",
          ...(metrics.length > 0 ? (["metric"] as const) : []),
        ]}
        hasContent
      />
    </>
  );
};
